"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageWizardStep = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const helpers_1 = require("../helpers");
const StackView_1 = require("../StackView");
const Text_1 = require("../Text");
const View_1 = require("../View");
const Title = (0, styled_components_1.default)(Text_1.Text) `
    line-height: ${helpers_1.FONT_LINE_HEIGHT_M};
    padding: 0 ${helpers_1.SPACING_XL} ${helpers_1.SPACING_M} 0;
`;
const HeaderContent = ({ title, description, indentBottom }) => {
    if (!title && !description) {
        return null;
    }
    return (react_1.default.createElement(StackView_1.StackView, { indentBottom: indentBottom, direction: StackView_1.STACK_DIRECTION.column, align: StackView_1.STACK_ALIGN.fill },
        title && (react_1.default.createElement(Title, { size: Text_1.TEXT_SIZE.l, weight: Text_1.TEXT_WEIGHT.bold, truncate: true }, title)),
        description && (react_1.default.createElement(View_1.View, null,
            react_1.default.createElement(Text_1.Text, null, description)))));
};
const Content = (0, styled_components_1.default)(StackView_1.StackView) `
    flex-shrink: 1;

    ${({ growContent }) => !growContent &&
    (0, styled_components_1.css) `
            width: fit-content;
        `}
`;
const Root = styled_components_1.default.div `
    display: flex;
    max-width: 100%;
    flex-grow: 1;
    flex-shrink: 1;
    align-self: stretch;
    flex-direction: column;

    ${({ growContent }) => growContent
    ? (0, styled_components_1.css) `
                  ${Content} {
                      align-self: stretch;
                      flex: 1 1 100%;
                  }
              `
    : (0, styled_components_1.css) `
                  flex: 1 1 100%;
                  align-items: stretch;
              `}
`;
exports.PageWizardStep = (0, helpers_1.createUIElement)('PageWizardStep', (_a, ref) => {
    var { className, title, description, content, contentIndentTop = View_1.INDENT.s, growContent, onClick, onMouseDown, onMouseUp, onMouseEnter, onMouseLeave, onKeyDown, onKeyUp, onKeyPress, style } = _a, rest = __rest(_a, ["className", "title", "description", "content", "contentIndentTop", "growContent", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    return (react_1.default.createElement(Root, Object.assign({}, rest, { "data-selector-id": rest['data-selector-id'], className: `vm-PageWizardStep ${className}`, growContent: growContent, onClick: onClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style }),
        react_1.default.createElement(HeaderContent, { title: title, description: description, indentBottom: contentIndentTop }),
        react_1.default.createElement(Content, { direction: StackView_1.STACK_DIRECTION.column, align: StackView_1.STACK_ALIGN.start, distribution: StackView_1.STACK_DISTRIBUTION.start, growContent: !!growContent }, content)));
});
//# sourceMappingURL=PageWizardStep.js.map